import { render, staticRenderFns } from "./ContentSkeleton.vue?vue&type=template&id=f110605e"
import script from "./ContentSkeleton.vue?vue&type=script&lang=js"
export * from "./ContentSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ContentSkeleton.vue?vue&type=style&index=0&id=f110605e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports